// accessible tabs. example used in tabs.liquid
(function () {
	const tabButtons = [...document.querySelectorAll("[data-expander-tab]")];
	const tabLists = [...document.querySelectorAll("[role='tablist']")];

	if (tabButtons.length !== 0 & tabLists.length !== 0) {


		setupActives();

		if (tabButtons.length !== 0) {
			tabButtons.forEach((tabButton) => {
				tabButton.addEventListener("click", (e) => {
					const currentTabButton = e.target;
					initiatePanel(currentTabButton);
				});
			});
		}

		if (tabLists.length !== 0) {
			let tabFocus = 0;

			tabLists.forEach((tabList) => {
				tabList.addEventListener("keydown", (e) => {
					if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
						tabButtons[tabFocus].setAttribute("tabindex", -1);
					}

					if (e.key === "ArrowRight") {
						tabFocus++;
						if (tabFocus >= tabButtons.length) {
							tabFocus = 0;
						}
					} else if (e.key === "ArrowLeft") {
						tabFocus--;
						if (tabFocus < 0) {
							tabFocus = tabButtons.length - 1;
						}
					}

					tabButtons[tabFocus].setAttribute("tabindex", 0);
					tabButtons[tabFocus].focus();
				});
			});
		}

		function initiatePanel(currentTabButton) {
			removeSettings();
			const tabId = currentTabButton.getAttribute("aria-controls");
			const tabTarget = document.getElementById(tabId);
			currentTabButton.setAttribute("aria-selected", true);
			tabTarget.removeAttribute("hidden");
			currentTabButton.classList.add("active");
			tabTarget.classList.add("active");
		}

		function removeSettings() {
			tabButtons.forEach((tabButton) => {
				const tabId = tabButton.getAttribute("aria-controls");
				const tabTarget = document.getElementById(tabId);
				tabButton.setAttribute("aria-selected", false);
				tabTarget.setAttribute("hidden", "true");
				tabButton.classList.remove("active");
				tabTarget.classList.remove("active");
			});
		}

		function setupActives() {
			const tabId = tabButtons[0].getAttribute("aria-controls");
			const tabTarget = document.getElementById(tabId);

			tabButtons[0].classList.add('active')
			tabButtons[0].setAttribute('aria-selected', true)
			tabButtons[0].setAttribute("tabindex", 0);
			tabTarget.classList.add("active");

		}
	}
})();

